export default {"src":"/hedera/_next/static/media/auditedModal.56de7dd0.svg","height":74,"width":60};